import React, { Component } from 'react'
import Parser from 'html-react-parser'

import Breadcrumbs from '../block/Breadcrumbs'

class App extends Component {

  render() {

    const data = this.props?.data

    return (
      <>
        <Breadcrumbs breadcrumbs={data?.breadcrumbs || []} />
        <div className='mt-[80px] xl:mt-[100px]'>
          <div className='container'>
            <div className='text-title text-ptblack uppercase tracking-tight leading-none'>{Parser(data?.h1 || data?.pagetitle)}</div>
            <div className='text-base text-ptgray leading-none mt-[10px] page_content'>
              {Parser(data?.content || '')}
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default App